import * as Types from '../../../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvoiceQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['String'];
}>;


export type InvoiceQuery = { readonly __typename?: 'Query', readonly invoice?: { readonly __typename?: 'Invoice', readonly _id: string, readonly invoiceStatus: Types.InvoiceStatus, readonly patientType: Types.PatientType, readonly created: string, readonly patient: { readonly __typename?: 'InvoicePatient', readonly insurance?: { readonly __typename?: 'InvoicePatientInsurance', readonly insuranceType: string, readonly insuranceDetails?: unknown | null } | null }, readonly balance: { readonly __typename?: 'Balance', readonly total?: number | null, readonly paid?: number | null, readonly due?: number | null, readonly currency?: Types.BillingCurrency | null }, readonly lineItems: ReadonlyArray<{ readonly __typename?: 'InvoiceLineItem', readonly id?: string | null, readonly quantity: number, readonly cost: number, readonly automated: boolean, readonly disabled: boolean, readonly incurredAt?: string | null, readonly supplier?: Types.LineItemSupplier | null, readonly missingPrice?: boolean | null, readonly priceListItem: { readonly __typename?: 'PriceListItem', readonly uuid?: string | null, readonly name: string, readonly priceListItemType: Types.PriceListItemType, readonly cost: number, readonly activeTariffId?: string | null, readonly revenueDepartment: string, readonly payers: ReadonlyArray<{ readonly __typename?: 'PayersTariff', readonly tariffId?: string | null, readonly name?: string | null, readonly amountInPence?: number | null, readonly revenueDepartment?: string | null }> }, readonly externalReference?: { readonly __typename?: 'PriceableItemExternalReference', readonly origin: Types.PriceableItemOrigin, readonly foreignId: string } | null }>, readonly payers: ReadonlyArray<{ readonly __typename?: 'Payer', readonly type: Types.PayerType, readonly name: string, readonly balance: { readonly __typename?: 'Balance', readonly total?: number | null, readonly paid?: number | null, readonly due?: number | null, readonly currency?: Types.BillingCurrency | null, readonly waived?: number | null, readonly exempt?: number | null }, readonly insuranceDetails?: { readonly __typename?: 'InsuranceDetails', readonly name?: string | null, readonly insuranceNumber?: string | null, readonly nationalIdNumber?: string | null, readonly dependent?: Types.Dependent | null } | null }> } | null };


export const InvoiceDocument = gql`
    query invoice($invoiceId: String!) {
  invoice(invoiceId: $invoiceId) {
    _id
    invoiceStatus
    patientType
    created
    patient {
      insurance {
        insuranceType
        insuranceDetails
      }
    }
    balance {
      total
      paid
      due
      currency
    }
    lineItems {
      id
      quantity
      cost
      automated
      disabled
      incurredAt
      priceListItem {
        uuid
        name
        priceListItemType
        cost
        payers {
          tariffId
          name
          amountInPence
          revenueDepartment
        }
        activeTariffId
        revenueDepartment
      }
      externalReference {
        origin
        foreignId
      }
      supplier
      missingPrice
    }
    payers {
      type
      name
      balance {
        total
        paid
        due
        currency
        waived
        exempt
      }
      insuranceDetails {
        name
        insuranceNumber
        nationalIdNumber
        dependent
      }
    }
  }
}
    `;

/**
 * __useInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoiceQuery(baseOptions: Apollo.QueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
      }
export function useInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
        }
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>;
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>;
export type InvoiceQueryResult = Apollo.QueryResult<InvoiceQuery, InvoiceQueryVariables>;